export const edwoneAddress = process.env.REACT_APP_EDWONE_ADDRESS || ''
export const pactAddress = process.env.REACT_APP_PACT_ADDRESS || ''
export const theWrigglerAddress = process.env.REACT_APP_THE_WRIGGLER_ADDRESS || ''
export const yoinkPowerExtractionChamberAddress = process.env.REACT_APP_YOINK_POWER_EXTRACTION_CHAMBER_ADDRESS || ''
export const isLocalDev = String(process.env.REACT_APP_LOCAL_CHAIN).toLowerCase() === 'true'
